import {action, observable, computed} from 'mobx';
import {VIEWS} from '../model/const';
import {getMatch} from '../utils/routingUtils';
import {roundTime} from '../utils';
import queryString from 'query-string';
import pathToRegexp from 'path-to-regexp';
import moment from 'moment';
import {setCookies as setTranslationCookies} from '../translate/actions';
import {initTranslations} from '../translate';

function moveToSS(query, queryKey, ssKey) {
  let value;
  if(query[queryKey]) {
    value = query[queryKey];
    window.sessionStorage.setItem(ssKey, value);  
  } else {
    value = window.sessionStorage.getItem(ssKey);
  }
}


export class Router {
  constructor(
    viewPatterns,
    history,
    authentication,
    vMaster,
    vHome,
    vSearch,
    vObjectDetails,
    vOfferDetails,
    vServices,
    vAccessories,
    vPersonalData,
    vReview,
    vPayment,
    vUserProfile,
    vUserRegistration,
    vRecentBookings,
    vRecentBookingDetail,
    vForgottenPassword,
    vFinished,
    onRedirect,
    onRedirectUnmerged,
  ) {
    this.viewPatterns = viewPatterns;
    this.history = history;
    this.authentication = authentication;
    this.vMaster = vMaster;
    this.vHome = vHome;
    this.vSearch = vSearch;
    this.vObjectDetails = vObjectDetails;
    this.vOfferDetails = vOfferDetails;
    this.vServices = vServices;
    this.vAccessories = vAccessories;
    this.vPersonalData = vPersonalData;
    this.vReview = vReview;
    this.vPayment = vPayment;
    this.vUserProfile = vUserProfile;
    this.vUserRegistration = vUserRegistration;
    this.vRecentBookings = vRecentBookings;
    this.vRecentBookingDetail = vRecentBookingDetail;
    this.vForgottenPassword = vForgottenPassword;
    this.vFinished = vFinished;

    this.onRedirect = onRedirect;
    this.onRedirectUnmerged = onRedirectUnmerged;

    this.currentView = undefined;
    this.currentViewPattern = undefined;
    this.avoidReenter = 0;
  }

  @observable currentViewPattern;
  @observable currentViewStep;

  @action.bound setParams(params) {
    for(let k in params) {
      if(params[k] !== undefined && params[k] !== null) {
        window.sessionStorage.setItem(k, params[k]);
      } else {
        window.sessionStorage.removeItem(k);
      }
    }
  }

  @action.bound initBrowserStoragesByUrl({path, params, query, location}) {
    if(path === VIEWS.chooseLessor) {
      window.sessionStorage.clear();
      return;
    }

    // Take scene setup parts from URL and put to SESSION STORAGE if any.
    if(query.trxId) {
      switch(path) {
        case VIEWS.bwOfferDetails:
        case VIEWS.bwServices:
        case VIEWS.bwAccessories:
        case VIEWS.bwPpersonalData:
        case VIEWS.bwRreview:
        case VIEWS.bwPayment:  
        case VIEWS.bwFinished:
          moveToSS(query, 'trxId', 'bwTrxId');   
          break;
        default:
          moveToSS(query, 'trxId', 'infoTrxId');
          break;
      }
    }    
    moveToSS(query, 'objId', 'objId');
    moveToSS(query, 'orgId', 'orgId');
    moveToSS(query, 'organizationId', 'orgId');
    moveToSS(query, 'rentalTransactionId', 'bwTrxId');
    switch(path) {
      case VIEWS.bwOfferDetails:
      case VIEWS.bwServices:
      case VIEWS.bwAccessories:
      case VIEWS.bwPersonalData:
      case VIEWS.bwReview:
      case VIEWS.bwPayment:  
        moveToSS(query, 'startDate', 'bwStartDate');
        moveToSS(query, 'duration', 'bwDuration');
        moveToSS(query, 'timeUnitId', 'bwTimeUnitId');
        break;
      case VIEWS.home:
      case VIEWS.search:
        moveToSS(query, 'startDate', 'searchStartDate');
        moveToSS(query, 'endDate', 'searchEndDate');
        moveToSS(query, 'duration', 'searchDuration');
        moveToSS(query, 'timeUnitId', 'searchTimeUnitId');    
        moveToSS(query, 'category', 'category');
        moveToSS(query, 'subcategory', 'subcategory'); 
        moveToSS(query, 'location', 'location');
        break;
      case VIEWS.recentBookingDetail:
        moveToSS(params, 'trxId', 'infoTrxId');
        break;
      case VIEWS.objectDetails:
        moveToSS(query, 'startDate', 'searchStartDate');
        moveToSS(query, 'endDate', 'searchEndDate');      
        moveToSS(query, 'duration', 'searchDuration');
        moveToSS(query, 'timeUnitId', 'searchTimeUnitId');
        break;
    }
    
    delete query.trxId;
    delete query.orgId;
    delete query.objId;
    delete query.startDate;
    delete query.endDate;
    delete query.duration;
    delete query.timeUnitId;
    delete query.category;
    delete query.subcategory;
    delete query.language;

    const newSearch = queryString.stringify(query);
    if(newSearch !== location.search) {
      try {
        this.avoidReenter++;
        this.history.replace({pathname: location.pathname, search: newSearch});
      }
      finally {
        this.avoidReenter--;
      }
    }    
  }

  @action.bound readParamsFromBrowserStorages({path}) {
    // Take scene setup parts from wherever it is stored.
    let objId = window.sessionStorage.getItem('objId');
    let trxId;
    switch(path) {
      case VIEWS.bwOfferDetails:
      case VIEWS.bwServices:
      case VIEWS.bwAccessories:
      case VIEWS.bwPersonalData:
      case VIEWS.bwReview:
      case VIEWS.bwPayment: 
      case VIEWS.bwFinished:
        trxId = window.sessionStorage.getItem('bwTrxId');
        break;
      default:
        trxId = window.sessionStorage.getItem('infoTrxId');
        break;
    } 
    let orgId = window.sessionStorage.getItem('orgId');


    let startDate;
    let endDate;
    let duration;
    let timeUnitId;
    let category;
    let subcategory;
    let locationId;
    switch(path) {
      case VIEWS.bwOfferDetails:
        startDate = window.sessionStorage.getItem('bwStartDate') || window.sessionStorage.getItem('searchStartDate');
        endDate = window.sessionStorage.getItem('bwEndDate') || window.sessionStorage.getItem('searchEndDate');
        duration = window.sessionStorage.getItem('bwDuration') || window.sessionStorage.getItem('searchDuration');
        timeUnitId = window.sessionStorage.getItem('bwTimeUnitId') || window.sessionStorage.getItem('searchTimeUnitId');  
        break;
      case VIEWS.bwServices:
      case VIEWS.bwAccessories:
      case VIEWS.bwPersonalData:
      case VIEWS.bwReview:
      case VIEWS.bwPayment:  
        startDate = window.sessionStorage.getItem('bwStartDate');
        endDate = window.sessionStorage.getItem('bwEndDate');
        duration = window.sessionStorage.getItem('bwDuration');
        timeUnitId = window.sessionStorage.getItem('bwTimeUnitId');      
        break;
      case VIEWS.home:
      case VIEWS.search:      
        startDate = window.sessionStorage.getItem('searchStartDate');
        endDate = window.sessionStorage.getItem('searchEndDate');
        duration = window.sessionStorage.getItem('searchDuration');
        timeUnitId = window.sessionStorage.getItem('searchTimeUnitId');  
        category = window.sessionStorage.getItem('category');
        subcategory = window.sessionStorage.getItem('subcategory');
        locationId = window.sessionStorage.getItem('location');
        break;
    }

    return {orgId, trxId, objId, startDate, endDate, duration, timeUnitId, category, subcategory, location: locationId};
  }

  @action.bound async handleAuthentication({location, path}) {
    
    if(!this.authentication.isUserLoaded) {
      await this.authentication.loadAuthenticatedUser();
    }

    switch(path) {
      case VIEWS.userProfile:
      case VIEWS.userBookings:
      //case ROUTES.userBookingDetail:
        if(!this.authentication.loggedIn) {
          this.history.replace({
            pathname: VIEWS.home,
            search: location.search,
          })
          throw "redirect";
        }
        break;
    }  
  }

  @action.bound async handleHistoryChange(location, action) {
    if(this.avoidReenter > 0) return;
    try {
      const {path, params, query} = getMatch(location, this.viewPatterns);
      this.currentViewPattern = path;
      if(query.language) {
        console.log('set translation cookies')
        setTranslationCookies(query.language);
        initTranslations();
      }
      
      this.initBrowserStoragesByUrl({path, params, query, location});
      let appSetup = this.readParamsFromBrowserStorages({path});

      if(location.pathname === '/confirmPayment') {
        this.history.replace({pathname: VIEWS.bwFinished, search: location.search});
        throw "redirect"
      }
      if(location.pathname === '/cancelPayment') {
        this.history.replace({pathname: VIEWS.bwPayment, search:location.search});
        throw "redirect"
      }
      if(location.pathname === '/errorPayment') {
        this.history.replace({pathname: VIEWS.bwPayment, search: location.search});
        throw "redirect"
      }

      if(location.pathname === '/confirmRegistration') {
        this.history.replace({
          pathname: pathToRegexp.compile(VIEWS.userRegistration)({
            step: 3,
          }), 
          search: location.search,
        });
        throw "redirect"
      }

      if(location.pathname === '/confirmPasswordReset') {
        this.history.replace({
          pathname: pathToRegexp.compile(VIEWS.forgottenPassword)({
            step: 3,
          }), 
          search: location.search,
        });
        throw "redirect"
      }

      // If orgId is not known, we should first choose some lessor.
      if(
        path !== VIEWS.chooseLessor && 
        !(path === VIEWS.userRegistration && params.step === "3") &&
        !(path === VIEWS.forgottenPassword && params.step === "3") &&
        !appSetup.orgId
      ) {
        //this.history.replace({pathname: VIEWS.chooseLessor});
        window.location.replace(window.location.pathname);
        throw "redirect"
      }

      if(path === VIEWS.root) {
        this.history.replace(VIEWS.home);
        throw "redirect"
      }      

      await this.handleAuthentication({location, path});

      const state = {...params, ...query, ...appSetup};
      if(this.currentView && this.currentView !== path) {
        this.currentView.stop && this.currentView.stop();
        this.currentView = undefined;
      }      
      switch(path) {
        case VIEWS.home:
          this.currentView = this.vHome;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.search:
          this.currentView = this.vSearch;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.objectDetails:
          this.currentView = this.vObjectDetails;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.bwOfferDetails:
          this.currentView = this.vOfferDetails;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.bwServices:
          this.currentView = this.vServices;
          this.currentView.startOrUpdate(state, this);
          break;        
        case VIEWS.bwAccessories:
          this.currentView = this.vAccessories;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.bwPersonalData:
          this.currentView = this.vPersonalData;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.bwReview:
          this.currentView = this.vReview;
          this.currentView.startOrUpdate(state, this);
          break;        
        case VIEWS.bwPayment:
          this.currentView = this.vPayment;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.bwFinished:
          this.currentView = this.vFinished;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.bwBookingSuccessful:
          break;
        case VIEWS.userProfile:
          this.currentView = this.vUserProfile;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.userRegistration:
          this.currentView = this.vUserRegistration;
          this.currentViewStep = params.step;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.recentBookings:
          this.currentView = this.vRecentBookings;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.recentBookingDetail:
          this.currentView = this.vRecentBookingDetail;
          this.currentView.startOrUpdate(state, this);
          break;
        case VIEWS.forgottenPassword:
          this.currentView = this.vForgottenPassword;
          this.currentViewStep = params.step;
          this.currentView.startOrUpdate(state, this);
          break;
      }
    } catch(e) {
      if(e !== "redirect") throw e;
    } finally {
      this.avoidReenter = 0;
    }
  }

  redirect(view, state) {
    this.onRedirect && this.onRedirect(view, state);
  }

  redirectUnmerged(view, state) {
    this.onRedirectUnmerged && this.onRedirectUnmerged(view, state);
  }

  @action.bound handleSceneChange(view, urlState, state) {

    switch(view) {
      case VIEWS.bwFinished:
        if(urlState.orgId) {
          delete urlState.message;
          delete urlState.orgId;
          delete urlState.trxId;
          delete urlState.targetTrxStatus;
          this.redirectUnmerged(view, urlState);
        }
        break;
      default:
        if(urlState.objId || urlState.orgId || urlState.organizationId) {
          for(let k in urlState) {
            if(['objId', 'orgId', 'organizationId'].indexOf(k) === -1) continue
            if(k !== 'step') {
              delete urlState[k];
            }
          }
          this.redirectUnmerged(view, urlState);
          return false;
        }
        break;
    }


    switch(view) {
      case VIEWS.root:
        this.redirect(VIEWS.home);
        return false;
      case VIEWS.confirmRegistration:
        this.redirect(VIEWS.userRegistration, {...state, step: 3});
        return false;
      case VIEWS.confirmPasswordReset:
        this.redirect(VIEWS.forgottenPassword, {...state, step: 3});
        return false;
      case VIEWS.confirmPayment:
        this.redirect(VIEWS.bwFinished, state);
        return false;
      case VIEWS.cancelPayment:
        this.redirect(VIEWS.bwPayment, state);
        return false;
      case VIEWS.errorPayment:
        this.redirect(VIEWS.bwPayment, state);
        return false;
    }    

    if(this.currentView && this.currentView !== view) {
      this.currentView.stop && this.currentView.stop();
      this.currentView = view;
    }

    switch(view) {
      case VIEWS.home:
        this.currentView = this.vHome;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.search:
        this.currentView = this.vSearch;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.objectDetails:
        this.currentView = this.vObjectDetails;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.bwOfferDetails:
        this.currentView = this.vOfferDetails;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.bwServices:
        this.currentView = this.vServices;
        this.currentView.startOrUpdate(state);
        break;        
      case VIEWS.bwAccessories:
        this.currentView = this.vAccessories;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.bwPersonalData:
        this.currentView = this.vPersonalData;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.bwReview:
        this.currentView = this.vReview;
        this.currentView.startOrUpdate(state);
        break;        
      case VIEWS.bwPayment:
        this.currentView = this.vPayment;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.bwFinished:
        this.currentView = this.vFinished;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.bwBookingSuccessful:
        break;
      case VIEWS.userProfile:
        this.currentView = this.vUserProfile;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.userRegistration:
        this.currentView = this.vUserRegistration;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.recentBookings:
        this.currentView = this.vRecentBookings;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.recentBookingDetail:
        this.currentView = this.vRecentBookingDetail;
        this.currentView.startOrUpdate(state);
        break;
      case VIEWS.forgottenPassword:
        this.currentView = this.vForgottenPassword;
        this.currentView.startOrUpdate(state);
        break;
    }
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/model/Router.js